import { ReactNode } from 'react';
import {
	Select as SelectMui,
} from '@mui/material';
import { ChildrenProps, InputProps, appendClassName } from '@componentLibraryWrapper/common';
import './select.scss';

interface SelectPropsIntermediary<R extends HTMLElement, T extends HTMLElement>
	extends Omit<ChildrenProps<T>, 'onBlur' | 'onChange' | 'onFocus'>,
		InputProps<R, T> {
}

export type SelectChangeEvent<Value = string> =
  | (Event & { target: { value: Value; name: string } })
  | React.ChangeEvent<HTMLInputElement>;

export interface SelectProps extends Omit<SelectPropsIntermediary<HTMLInputElement | HTMLTextAreaElement, HTMLDivElement>, 'onChange'> {
	labelId?: string,
	onChange?: ((event: SelectChangeEvent<any>, child: ReactNode) => void),
	multiple?: boolean
}

const Select = ({
	className,
	inputRef,
	multiple=false,
	...rest
}: SelectProps) => {

	return (
		<SelectMui
			{...rest}
			className={appendClassName('sm-select', className)}
			multiple={multiple}/>
	)
}

export default Select;